import {ActionTree} from 'vuex';
import axios from 'axios';
import {RootState} from '@/store/types';
import {StatisticState, DetailFilterParams, GroupFilterParams} from './types';

export const actions: ActionTree<StatisticState, RootState> = {
  async getCustomStatisticDetail({commit}, data: DetailFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/detail/custom',
        params: data
      });
      let messages = resp.data?.messages ?? []
      if (data.page_number > 1) {
        commit('pushCustomStatisticDetail', messages);
      } else {
        commit('setCustomStatisticDetail', messages);
      }
      return resp;
    } catch (error) {
      throw error;
    }
  },
  async exportCustomStatisticDetail({commit}, data: DetailFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/detail/custom/export',
        params: data
      });
      return resp;
    } catch (error) {
      throw error;
    }
  },
  async getCustomStatisticDetailInfo({ commit, dispatch }, id: string) {
    try {
      const resp = await axios({
        url: "/stats-api/detail/custom/" + id.replace(/#/g, "%23"),
      });
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getCustomStatisticGroup({commit}, data: GroupFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/group/custom',
        params: data
      });
      commit('setCustomStatisticGroup', resp.data);
      return resp;
    } catch (error) {
      throw error;
    }
  },
  async exportCustomStatisticGroup({commit}, data: GroupFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/group/custom/export',
        params: data
      });
      return resp;
    } catch (error) {
      throw error;
    }
  },
};